import { Component, OnInit } from '@angular/core';
import { HelperService } from '../helper.service';
import {Router} from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";  
import {
  UserService
} from '../user.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  isUserLoggedIn = false;
  current_url:string = this.router.url;
  constructor(private helper:HelperService,private router: Router, private SpinnerService: NgxSpinnerService,public UserService : UserService) { 
    this.isUserLoggedIn = this.helper.isUserLoggedIn();
  }
  profileImage: string;
  fileuploadurl = this.UserService.profile_image_url;
  ngOnInit(): void {
    this.profileImage = localStorage.getItem('nu_profile_image') != 'null' ? localStorage.getItem('nu_profile_image') : '';
    this.current_url = this.getUrlWithoutParams();
    ////console.log(this.current_url);
  }
  getUrlWithoutParams(){
    let urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {}; 
    return urlTree.toString();
  }
  logoutClicked(event){
    this.SpinnerService.show(); 
    document.body.classList.remove('modal-open');
    document.querySelector(".modal-backdrop").remove();
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  
}

